import { FilterOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { t } from "i18next";
import * as React from "react";
import { ClosableTag } from "src/components/ClosableTag";
import { LeftCollapsedPanels } from "src/components/LeftCollapsedPanels";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import {
  AbstractFilters,
  AbstractRow,
  RtKey,
} from "src/components/ReactiveTable/RtTypes";
import { ToolBox2 } from "src/components/ToolBox2";

import * as styles from "./AttrSelectTableLayout.module.less";

type PropsAttrSelectTableLayout<
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
> = {
  table: RtStore<TRow, TFilters>;
  columns: RtColumn<TRow>[];
  makeOption: (
    key: RtKey,
    row?: TRow,
  ) => { value: RtKey; label: React.ReactNode };
  leftPart: React.ReactNode;
  activeFilterLabel?: React.ReactNode;
  onClearFilter: () => void;
  mainTools?: React.ReactNode;
  extraTools?: React.ReactNode;
};

export const AttrSelectTableLayout = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>(
  props: PropsAttrSelectTableLayout<TRow, TFilters>,
) => {
  const {
    table,
    columns,
    makeOption,
    leftPart,
    activeFilterLabel,
    onClearFilter,
    mainTools,
    extraTools,
  } = props;

  return (
    <ToolBox2 mainTool={<RtSelection store={table} makeOption={makeOption} />}>
      <LeftCollapsedPanels
        leftTitle={
          <Space>
            <FilterOutlined />
            <span>{t("Filter")}</span>
          </Space>
        }
        leftPart={leftPart}
        className={styles.withBorder}
      >
        <ToolBox2
          toolsClass={styles.tools}
          mainTool={mainTools}
          extraTools={
            <>
              {extraTools}
              <MdmTableSystemTools store={table} />
            </>
          }
        >
          <ToolBox2
            toolsClass={styles.tools}
            mainTool={
              <ClosableTag label={activeFilterLabel} onClose={onClearFilter} />
            }
          >
            <MdmTable store={table} columns={columns} resizableColumns />
          </ToolBox2>
        </ToolBox2>
      </LeftCollapsedPanels>
    </ToolBox2>
  );
};
